import { IPartnerContact } from 'partner360/features/contacts'

import { IContactSearchItem } from '../models/IContactSearchItem'

export const mapContactSearchItem = (
  item: any,
  partnerContacts: IPartnerContact[]
): IContactSearchItem => {
  return {
    roles: item.Roles,
    contactId: item.ContactID,
    entryId: item.EntryID,
    firstName: item.FirstName,
    lastName: item.LastName,
    fullName: [item.FirstName, item.LastName].filter(Boolean).join(' ').trim() || '-',
    email: item.Email,
    isInContacts: partnerContacts.some((contact) => contact.ContactId === item.ContactID),
  }
}
